function initSmgCoachingPackagesSwiper(root) {
  var el = root.querySelector('[data-smg-coaching-packages-swiper]');
  if (!el || typeof Swiper === 'undefined') return;
  if (el.swiper) el.swiper.destroy(true, true);

  new Swiper(el, {
    slidesPerView: 1.1,
    centeredSlides: false,
    spaceBetween: 16,
    a11y: {
      prevSlideMessage: 'Previous package',
      nextSlideMessage: 'Next package'
    },
    breakpoints: {
      568: {
        slidesPerView: 1.2,
        centeredSlides: false,
        spaceBetween: 16
      },
      992: {
        slidesPerView: 'auto',
        enabled: false
      }
    }
  });
}

function initAllSmgCoachingPackages(scope) {
  var sections = (scope || document).querySelectorAll('.smg-coaching-packages');
  sections.forEach(function (section) {
    initSmgCoachingPackagesSwiper(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllSmgCoachingPackages(document);
  });
} else {
  initAllSmgCoachingPackages(document);
}

document.addEventListener('shopify:section:load', function (e) {
  initAllSmgCoachingPackages(e.target);
});

function handleCoachingAtcSubmit(e) {
  var form = e.target.closest('.smg-coaching-packages-atc-form');
  if (!form) return;
  e.preventDefault();

  var btn = form.querySelector('.smg-coaching-packages__cta');
  var feedback = form.querySelector('.smg-coaching-packages__atc-feedback');
  var formData = new FormData(form);

  if (btn) {
    btn.disabled = true;
    btn.classList.add('smg-coaching-packages__cta--loading');
  }
  if (feedback) feedback.textContent = '';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: formData.get('id'),
      quantity: formData.get('quantity'),
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    })
  })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (err) { throw err; });
      return res.json();
    })
    .then(function (state) {
      if (feedback) feedback.textContent = 'Added!';
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(state);
      }
    })
    .catch(function (err) {
      if (feedback) feedback.textContent = (err && err.description) || 'Error adding to cart';
    })
    .finally(function () {
      if (btn) {
        btn.disabled = false;
        btn.classList.remove('smg-coaching-packages__cta--loading');
      }
    });
}

document.addEventListener('submit', handleCoachingAtcSubmit);
